<template>
  <div>
    <v-layout align-center>
      <v-flex shrink>
        <v-checkbox
          :disabled="toggling"
          :input-value="isProvider"
          class="ma-0"
          hide-details
          @mousedown.native="toggle"/>
      </v-flex>
      <v-flex grow>
        <div class="body-1">
          <a
            class="body-2 clickable"
            href="http://www.endeavourenergy.com.au/outages">
            Endeavour Energy</a>
          <span class="ml-3 caption grey--text text--darken-1">
            Not supported
          </span>
        </div>
      </v-flex>
    </v-layout>
    <v-divider/>
  </div>
</template>

<script>
export default {
  name: "endeavour-energy",
  data () {
    return {
      error: null,
      isProvider: false,
      toggling: false
    };
  },
  created () {
    this.refresh();
  },
  methods: {
    refresh () {
      this.toggling = true;
      return this.$http.
        get(
          `/api/sites/${this.$route.params.id}/providers/endeavour-energy`,
          { headers: { "Cache-Control": "no-cache" } }
        ).
        then((r) => this.isProvider = r.data).
        catch(() => this.$emit("error")).
        finally(() => this.toggling = false);
    },
    toggle () {
      if (this.isProvider) {
        this.toggling = true;
        this.$http.
          delete(`/api/sites/${this.$route.params.id}/providers/endeavour-energy`).
          then(() => this.refresh()).
          catch(() => this.$emit("error")).
          finally(() => this.toggling = false);
      } else {
        this.toggling = true;
        this.$http.
          put(`/api/sites/${this.$route.params.id}/providers/endeavour-energy`).
          then(() => this.refresh()).
          catch(() => this.$emit("error")).
          finally(() => this.toggling = false);
      }
    }
  }
};
</script>

<style scoped>
.layout {
  height: 36px;
}
</style>



// WEBPACK FOOTER //
// src/components/Site/Outages/EndeavourEnergy.vue